$(document).ready(function(){

    if ( $('.oz__option-set').length ){

        // Create Customisation Section
        $('.product-form__quantity').after('<section id="customisation"></section>');

        // Loop through current customisation options
        $('.oz__option-set .oz__options .oz__option').each(function(i){

            // Create Div
            var option_id = i + 1
            $('#customisation').append('<div id="option_' + option_id + '" class="options" data-count="' + option_id + '"></div>')

            var label = $(this).find('.oz__option-label').text().replace(/\(.*/,'');

            $('#option_' + option_id +'').append('<span>' + label + '</span>')
        
            $(this).find('select option').each(function(count){

                var option_text = $(this).text()
                var option_value = option_text.split('(')[0];
                var option_price = option_text.split('(')[1];

                if ( option_value != "Select an option" ){

                    if ( option_price ){

                        if ( count == 1 ){
                            $('#option_' + option_id +'').append('<div class="option active nopop" data-count="'+ count +'"><p>'+ option_value + '<br> (' + option_price +'</p></div>');
                        } else {
                            $('#option_' + option_id +'').append('<div class="option" data-count="'+ count +'"><p>'+ option_value + '<br> (' + option_price + '</p></div>');
                        }

                    } else {

                        if ( count == 1 ){
                            $('#option_' + option_id +'').append('<div class="option active nopop" data-count="'+ count +'"><p>'+ option_value + '</p></div>');
                        } else {
                            $('#option_' + option_id +'').append('<div class="option" data-count="'+ count +'"><p>'+ option_value + '</p></div>');
                        }

                    }

                }

            });

            if (i == 1){
                $('#option_'+ option_id +' .option').each(function(){
                    $(this).addClass('nopop');
                })
            }

        });

        $('#customisation .option').click(function(i){

            if ( !$(this).hasClass('active') ){

                $(this).parent().find('.active').removeClass('active');
                $(this).addClass('active');

                var parent = $(this).parent()
                var option_title = parent.find('span').text()
                var option_number = $(this).attr('data-count');

                $('.oz__option').each(function(i){

                    var label = $(this).find('.oz__option-label').text().replace(/\(.*/,'');

                    if (label.includes(option_title) ){

                        $(this).find('select option').each(function(idx){

                            if ( idx == option_number ) {
                                var value = $(this).val();
                                var select = $(this).parent();

                                select.val(value).each(function() {
                                    this.dispatchEvent(new Event('change', { bubbles: true }));
                                });

                                return false;
                            }

                        })


                    }

                })

                if ( !$(this).hasClass('nopop')){
                    updatePopup(true);
                }
            
            } else {

                if ( !$(this).hasClass('nopop')){
                    updatePopup(false);
                }

            }

        });
    
    }

    $('.additional-content .blocks .block').click(function(){

        if ( $(this).hasClass('active') ){
            $(this).removeClass('active')
        } else {
            $('.additional-content .blocks .block').removeClass('active');
            $(this).addClass('active');
        }

    });

});

function updatePopup(clear){

    $(document).ready(function(){
        var length = $('.oz__options .oz__option').length
        var sub_idx = length - 1

        if ( clear == true ){
            $('.popup-modal .content').empty();

            $('.oz__options .oz__option').each(function( idx ){

                if ( (idx != 0) && (idx != sub_idx ) ){
                    
                    // Get Option Info
                    var label = $(this).find('.oz__option-label').text().replace(/\(.*/,'');
                    $('.popup-modal .content').append('<div class="options" id="option_'+ idx +'"><span>'+ label +'</span></div>')

                    // Container
                    var container = $('.popup-modal .content #option_'+ idx +'');

                    // Set Required Variable
                    var required = false;

                    // Check for select or input type
                    if ( $(this).find('select').length ){

                        if ( $(this).find('select').attr('required') ){
                            required = true;
                        }
                        
                        $(this).find('select option').each(function( option_idx ){

                            if ( option_idx != 0 ){
                                var text = $(this).text();
                                var text_split = text.split('(+');
                                var text_only = text_split[0];
                                var price_only = text_split[1];

                                if ( price_only ){
                                    container.append('<div class="option" data-count="'+ option_idx +'"><p>'+ text_only +' <br> (+'+ price_only +'</p></div>');
                                } else {

                                    if ( label == "Font " ){
                                        if ( text.indexOf('Times') != -1 ){
                                            var fontFamily = 'Times New Roman, Times, serif';

                                        } else if ( text.indexOf('Corsiva') != -1){
                                            var fontFamily = 'inherit';

                                        } else if ( text.indexOf('Arial') != -1){
                                            var fontFamily = 'Arial, Helvetica, sans-serif';

                                        } else if ( text.indexOf('Comic') != -1 ){
                                            var fontFamily = 'Comic Sans MS, cursive';

                                        } else if ( text.indexOf('Script') != -1 ){
                                            var fontFamily = 'Style Script, cursive';

                                        } else {
                                            var fontFamily = 'inherit';
                                        }
                                        container.append('<div class="option" data-count="'+ option_idx +'"><p style="font-family: '+ fontFamily +'; font-size: 15px; ">'+ text +'</p></div>');
                                    } else {
                                        container.append('<div class="option" data-count="'+ option_idx +'"><p>'+ text +'</p></div>');
                                    }

                                }

                            }

                        });

                    } else if ( $(this).find('input').length ){

                        if ( $(this).find('input').attr('required') ){
                            required = true;
                        }

                        var type = $(this).find('input').attr('type');
                        container.append('<input type="'+ type +'" >');

                    }

                    if (required){
                        container.addClass('required');
                        container.find('span').append(' *')
                    }


                }

            })

            $('.popup-modal .content').append('<span class="btn">Save</span>');
            $('.popup-modal .content .btn').click(function(e){
                e.preventDefault();

                var allow_add_to_cart = true;
                
                $('.popup-modal .content .options.required').each(function(){
                    if ( !$(this).find('.active').length ){
                        allow_add_to_cart = false;

                        if ( $(this).find('.requiredText').length == 0){
                            $(this).append('<div class="requiredText"></div>');
                        }

                    } else {
                        $(this).find('.requiredText').remove();
                    }
                })

                if ( allow_add_to_cart ){
                    $('.popup-modal').hide();
                    $('#customisation .options .options.active').removeClass('active');
                    $('#customisation .options .options.nopop').addClass('active');
                } else {
                    $('.requiredText').text("Please select an option");
                }

            });

        }

        $('.popup-modal .options .option').click(function(){

            if ( !$(this).hasClass('active') ){

                $(this).parent().find('.active').removeClass('active');
                $(this).addClass('active');

                var parent = $(this).parent()
                var option_title = parent.find('span').text().replace(' *', '');
                var option_number = $(this).attr('data-count');

                $('.oz__option').each(function(i){
                    var label = $(this).find('.oz__option-label').text().replace(/\(.*/,'');

                    if (label.includes(option_title) ){

                        $(this).find('select option').each(function(idx){

                            if ( idx == option_number ) {
                                var value = $(this).val();
                                var select = $(this).parent();

                                select.val(value).each(function() {
                                    this.dispatchEvent(new Event('change', { bubbles: true }));
                                });

                                return false;
                            }

                        })


                    }

                })
            
            } 

        });

        $('.popup-modal input[type="text"]').on('input', function(){
            var value = $(this).val()
            var parent = $(this).parent()
            var option_title = parent.find('span').text()

            $('.oz__option').each(function(i){
                var label = $(this).find('.oz__option-label').text().replace(/\(.*/,'');

                if (label.includes(option_title) ){
                    var input = $(this).find('input')

                    input.val(value).each(function(){
                        this.dispatchEvent(new Event('change', { bubbles: true }));
                        this.dispatchEvent(new Event('input', { bubbles: true }));
                        this.dispatchEvent(new Event('keyup', { bubbles: true }));
                    })

                    return false;

                }
            
            });

        });

        $('.popup-modal input[type="file"]').on('click', function(e){
            e.preventDefault();

            var parent = $(this).parent()
            var option_title = parent.find('span').text()

            $('.oz__option').each(function(i){
                var label = $(this).find('.oz__option-label').text().replace(/\(.*/,'');

                if (label.includes(option_title) ){

                    var file_input = $(this).find('input')
                    file_input.trigger('click');
                    file_input.on('change', function(){
                        parent.empty();                        
                        parent.append('<div class="upload_success" data-title="'+ option_title +'"><span>File Uploaded - click here to reupload your file</span></div>')

                        reuploadFile()

                    });

                }

            });

        });

        $('.popup-modal').css('display', 'flex');
        $('.section-header.shopify-section-group-header-group').css('z-index', '0');
        $('.popup-modal .overlay').click(function(){
            $('.popup-modal').hide();
            $('.section-header.shopify-section-group-header-group').css('z-index', '3');
        });

    });

}

function reuploadFile(){

    $('.upload_success').click(function(){
        var option_title = $(this).attr('data-title');

        $('.oz__option').each(function(i){
            var label = $(this).find('.oz__option-label').text().replace(/\(.*/,'');

            if (label.includes(option_title) ){
                var file_input = $(this).find('input')

                file_input.trigger('click');
                file_input.on('change', function(){
                    parent.empty();                        
                    parent.append('<div class="upload_success" data-title="'+ option_title +'"><span>File Uploaded - click here to reupload your file</span></div>')
                });

            }

        });

    });

}